import debounce from "lodash.debounce";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";

import Search from "../../Search/Search";
import Title from "../../../common/Title";
import BatchList from "../../../common/BatchList";

import useAxios from "../../../../hooks/useAxios";
import { CLIENTS, OPERATIONS } from "../../../../constants/value";
import { __getTmobilejFilterGroupAssignBatches } from "../../../../api/sim";

const TmobilejFilterGroupAssign = () => {
  const [data, setData] = useState([]);
  const nav = useNavigate();

  const [searchActive, setSearchActive] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [metaData, setMetaData] = useState({
    page: 1,
    page_size: 100,
    total: 1,
  });

  const [response, call, loading] = useAxios({
    ...__getTmobilejFilterGroupAssignBatches,
  });

  const debouncedFetchData = debounce((query) => {
    call(query);
  }, 500);

  useEffect(() => {
    debouncedFetchData({
      params: {
        page: currentPage,
        page_size: pageSize,
        client: CLIENTS.tmobilej,
      },
    });
    return () => debouncedFetchData.cancel();
  }, [currentPage, pageSize]);

  useEffect(() => {
    if (!response?.status) return;
    setMetaData({
      page: response.data.page,
      page_size: response.data.page_size,
      total: response.data.total,
    });
    setData(response.data.data);
  }, [response]);

  return (
    <Box sx={{ width: "100%" }}>
      <Title
        variant="h5"
        sx={{ textTransform: "capitalize" }}
        content="Tmobilej Bulk Assign Filter Groups"
        gutterBottom
      />
      <Search
        key="tmobilej-assign-filter-groups"
        client={CLIENTS.tmobilej}
        operation={OPERATIONS.assign_filter_groups}
        searchActive={searchActive}
        setSearchActive={setSearchActive}
      />
      {!searchActive &&
        (response ? (
          <>
            <Grid container justifyContent="flex-start" spacing={2}>
              <Grid item>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => nav("form")}
                  >
                    Assign Filter Groups
                  </Button>
                </Stack>
              </Grid>
            </Grid>
            <BatchList
              data={data}
              loading={loading}
              meta={metaData}
              handlePageChange={setCurrentPage}
              handlePageSizeChange={(s) => {
                setCurrentPage(1);
                setPageSize(s);
              }}
            />
          </>
        ) : (
          <Title content="Please wait..." variant="subtitle2" gutterBottom />
        ))}
    </Box>
  );
};

export default TmobilejFilterGroupAssign;
